import React from "react";

const loadDashboardPages = {
  overview: () => import("../../pages/dashboard/overview/index.jsx"),
  reservations: () => import("../../pages/dashboard/reservations/index.jsx"),
  reservationCancel: () =>
    import("../../pages/dashboard/cancel-reservation/Cancel-reservations.jsx"),
  confirmCancellation: () =>
    import(
      "../../pages/dashboard/confirm-cancellation/confirm-cancellation.jsx"
    ),
  notification: () => import("../../pages/dashboard/notifications/index.jsx"),
  reviews: () => import("../../pages/dashboard/reviews/main-tab/index.jsx"),
  WriteReview: () =>
    import("../../pages/dashboard/reviews/edit-write-review/write/index.jsx"),
  EditReview: () =>
    import("../../pages/dashboard/reviews/edit-write-review/edit/index.jsx"),
  editProfile: () => import("../../pages/dashboard/edit-profile/index.jsx"),
  Messages: () => import("../../pages/dashboard/messages/index.jsx"),
  payment: () => import("../../pages/dashboard/payments/index.jsx"),
  wishlist: () => import("../../pages/dashboard/wishlist/index.jsx"),
  singleReservation: () =>
    import("../../pages/dashboard/single-reservation/index.jsx"),
};

const dashboardLazyPages = {
  overview: React.lazy(() => loadDashboardPages.overview()),
  reservations: React.lazy(() => loadDashboardPages.reservations()),

  reservationCancel: React.lazy(() => loadDashboardPages.reservationCancel()),
  confirmCancellation: React.lazy(() =>
    loadDashboardPages.confirmCancellation()
  ),

  notification: React.lazy(() => loadDashboardPages.notification()),
  wishlist: React.lazy(() => loadDashboardPages.wishlist()),
  reviews: React.lazy(() => loadDashboardPages.reviews()),
  WriteReview: React.lazy(() => loadDashboardPages.WriteReview()),
  EditReview: React.lazy(() => loadDashboardPages.EditReview()),
  editProfile: React.lazy(() => loadDashboardPages.editProfile()),
  Messages: React.lazy(() => loadDashboardPages.Messages()),
  payment: React.lazy(() => loadDashboardPages.payment()),
  singleReservation: React.lazy(() => loadDashboardPages.singleReservation()),
};

export { loadDashboardPages, dashboardLazyPages };
